import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Root from '~/root';

import { initScroll } from './scroll';

ReactDOM.render(<Root />, document.getElementById('app'));

try {
  initScroll();
} catch (e) {}
